import { useParams } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "../../../../redux/store";
import React, { useEffect, useState } from "react";
import { ClpData } from "../../../../models/Clp";
import { fetchClp } from "../../../../services/clp-service";
import { fetchUser } from "../../../../services/userService";
import { fetchProperty } from "../../../../services/propertyService";
import { useTranslation } from "react-i18next";
import { IUser } from "../../../../models/User";
import { getUserProfile } from "../../../../selectors";
import { Property } from "../../../../models/Property";
import { fetchCompany } from "../../../../redux/actions/companyActions";
import {fetchUnits} from "../../../../services/unitsService";
import {getTextByCurrentLanguage, replaceText} from "../../../../utils/functions";
import {fetchA11yStandard} from "../../../../redux/actions/a11yStandardActions";
import CustomBreadcrumbs from "../../../../components/CustomBreadcrumbs";
import CustomTabs from "../../../../components/CustomTabs";
import ChecklistPointsTab from "./components/ChecklistPointsTab";
import ChecklistCostsTab from "./components/ChecklistCostsTab";
import ChecklistDataTab from "./components/ChecklistDataTab";

const ChecklistItem = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const params: {id: string} = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [clpData, setClpData] = useState<ClpData[]>([]);
  const [property, setProperty] = useState<Property>(null!)
  const user = useSelector((state) => state.authReducer.user);
  const userProfile = useSelector<IUser | undefined>(getUserProfile);
  const a11yStandard = useSelector((state) => state.a11yStandardReducer.a11yStandard)
  const [currentTab, setCurrentTab] = useState(0)

  const fetchClpData = async () => {
    const currentA11yStandard = a11yStandard.find((i) => i.key === property.a11y_standard)
    let result = await fetchClp(params.id, user!.token)
      .then(async (data) => {
        if (data.length > 0) {
          const units = await fetchUnits(params.id, user!.token)
          const users = []
          for await (let item of data) {
            let order = 0
            let foundUnit: any = null

            if (units?.data?.results?.length > 0) {
              foundUnit = units.data.results.find((i) => i.id === item.id)
              order = foundUnit ? foundUnit?.order : 0
            }

            item.order = order
            item.clps = item.clps.map((clp) => ({
              ...clp,
              q_title: replaceText(
                  clp.q_title,
                  item.title,
                  foundUnit? foundUnit.title : '',
                  currentA11yStandard ? currentA11yStandard.title : ''
              ),
              description: replaceText(
                  clp.description,
                  item.title,
                  foundUnit? foundUnit.title : '',
                  currentA11yStandard ? currentA11yStandard.title : ''
              )
            }))

            if (item.clps.length > 0) {
              for await (let clp of item.clps) {
                if (clp.updated_by) {
                  const findUser = users.find((i) => i.id === clp.updated_by)
                  if (findUser) {
                    clp.updated_by = `${findUser.first_name} ${findUser.last_name}`
                  } else {
                    let updatedUser: any = null
                    try {
                      updatedUser = await fetchUser(clp.updated_by, user!.token)
                    } catch (e) {
                      clp.updated_by = 'Unknown user'
                    }
                    if (updatedUser) {
                      users.push(updatedUser.data)
                      clp.updated_by = `${updatedUser.data.first_name} ${updatedUser.data.last_name}`
                    }
                  }
                }
              }
            }
          }
          // @ts-ignore
          data = data.sort((a: any, b: any) => a?.order > b.order)
        }
        return data
      })

    setClpData(result)
    setIsLoading(false)
  }

  useEffect(() => {
    if (userProfile && userProfile.company) {
      dispatch(fetchCompany(userProfile.company, user!.token));
    }
  }, [userProfile])

  const fetchPropertyData = async () => {
    const result = await fetchProperty(params.id, user!.token)
    setProperty(result.data)
  }

  useEffect(() => {
    if (a11yStandard.length === 0) {
      dispatch(fetchA11yStandard(user!.token))
    }
  }, [])

  useEffect(() => {
    if (a11yStandard.length > 0) {
      fetchPropertyData()
    }
  }, [a11yStandard]);

  useEffect(() => {
    if (property) {
      fetchClpData()
    }
  }, [property]);

  const getTabContent = (tab: number) => {
    const TABS: {[key: number]: React.ReactNode} = {
      0: <ChecklistDataTab data={clpData} isLoading={isLoading}/>,
      1: <ChecklistCostsTab data={clpData} isLoading={isLoading}/>,
      2: <ChecklistPointsTab property={property} data={clpData} onSetData={setClpData} isLoading={isLoading}/>,
    }
    return TABS[tab]
  }

  return (
    <Box p={12} className={`disable-scrolls`} overflow="scroll">
      <Typography variant="h3" gutterBottom display="inline">
        {t("routes_Clp")}
      </Typography>
      <CustomBreadcrumbs
          current={getTextByCurrentLanguage(property?.name)}
          before={[
            {to: '/', title: t('dashboard')},
            {to: '/checklist', title: t('routes_Clp')}
          ]}
      />
      <Box my={6}>
        <CustomTabs tabs={['Data', 'Costs', 'Checklist points']} value={currentTab} setValue={setCurrentTab}/>
      </Box>
      {getTabContent(currentTab)}

    </Box>
  )
}

export default ChecklistItem
